/** stok — Lots, holds and expiry. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enStokLots = {
  // ---- Status ---------------------------------------------------------------------------
  'stok.lotStatus.available': 'Available',
  'stok.lotStatus.on_hold': 'On hold',
  'stok.lotStatus.quarantined': 'Quarantined',
  'stok.lotStatus.recalled': 'Recalled',

  // ---- Expiry ---------------------------------------------------------------------------
  'stok.lots.expiry.none': 'No expiry',
  'stok.lots.expiry.today': 'Expires today',
  'stok.lots.expiry.pastOne': 'Expired 1 day ago',
  'stok.lots.expiry.past': 'Expired {days} days ago',
  'stok.lots.expiry.leftOne': '1 day left',
  'stok.lots.expiry.left': '{days} days left',

  // ---- List -----------------------------------------------------------------------------
  'stok.lots.title': 'Lots & expiry',
  'stok.lots.subtitle': 'Stock per lot in {branch}, with expiry dates, holds and value.',
  'stok.lots.alertsTitle': 'Expiry alerts',
  'stok.lots.alertsDesc':
    'Lots with stock that are expired or expire within the chosen horizon. Days count from the business date {date}.',
  'stok.lots.alertsDescShort':
    'Lots with stock that are expired or expire within the chosen horizon.',
  'stok.lots.horizon': 'Alert horizon',
  'stok.lots.horizonDays': '{days} days',
  'stok.lots.expiredCount': 'Expired lots',
  'stok.lots.expiredCountDesc': 'Still in stock after their expiry date.',
  'stok.lots.expiringCount': 'Expiring within {days} days',
  'stok.lots.expiringCountDesc': 'Use these first (first expired, first out).',
  'stok.lots.exposure': 'Value at average cost:',
  'stok.lots.expiredList': 'Expired',
  'stok.lots.expiringList': 'Expiring within {days} days',
  'stok.lots.alertsNoneExpired': 'No expired lots in stock.',
  'stok.lots.alertsNoneExpiring': 'No lots expire within {days} days.',
  'stok.lots.alertsMore': '+{count} more — see the list below.',
  'stok.lots.allStatuses': 'All statuses',
  'stok.lots.searchPlaceholder': 'Lot code, item, SKU or source',
  'stok.lots.includeEmpty': 'Include used-up lots',
  'stok.lots.listTitle': 'Lots',
  'stok.lots.listDesc': 'Quantity per lot and location. Value = quantity × branch average cost.',
  'stok.lots.empty':
    'No lots in stock — lots are created when lot-tracked items are received or get an opening balance.',
  'stok.lots.emptyFiltered': 'No lots match this filter.',
  'stok.lots.col.code': 'Lot code',
  'stok.lots.col.expiry': 'Expiry',
  'stok.lots.open': 'Open lot {code}',
  'stok.lots.source.goodsReceipt': 'Goods receipt',
  'stok.lots.source.waste': 'Waste record',

  // ---- Detail ---------------------------------------------------------------------------
  'stok.lots.back': 'All lots',
  'stok.lots.detailLoading': 'Lot',
  'stok.lots.detailTitle': 'Lot {code}',
  'stok.lots.detailSubtitle': '{item} · {sku}',
  'stok.lots.factsTitle': 'Lot details',
  'stok.lots.factsDesc': 'Days to expiry count from the business date {date}.',
  'stok.lots.fact.expiry': 'Expiry date',
  'stok.lots.fact.manufactured': 'Manufactured',
  'stok.lots.fact.receivedAt': 'Received at',
  'stok.lots.fact.supplier': 'Supplier',
  'stok.lots.fact.qty': 'Quantity in stock',
  'stok.lots.fact.valueHint': 'Quantity × branch average cost',
  'stok.lots.balancesTitle': 'Stock per location',
  'stok.lots.balancesDesc': 'Where the quantity of this lot is now.',
  'stok.lots.balancesEmpty': 'No stock left in this lot.',
  'stok.lots.actionsTitle': 'Hold and release',
  'stok.lots.actionsDesc':
    'A held lot stays in stock but is not offered for use until it is released.',
  'stok.lots.readOnly': 'Your role can view lots but not hold or release them.',
  'stok.lots.releaseNeedsApprove':
    'This lot is on hold. Releasing it needs the approval permission — ask a manager.',
  'stok.lots.holdNeedsReceive': 'Holding a lot needs the receiving permission.',
  'stok.lots.recalledNote': 'This lot is recalled and cannot be released here.',
  'stok.lots.hold': 'Hold lot',
  'stok.lots.holding': 'Holding…',
  'stok.lots.holdTitle': 'Hold lot {code}?',
  'stok.lots.holdBody':
    'The lot stays in stock but is blocked for use (FEFO skips it) until it is released.',
  'stok.lots.holdReason': 'Reason',
  'stok.lots.holdHint': 'For example: “Packaging damaged, waiting for the supplier”.',
  'stok.lots.held': 'Lot {code} is on hold.',
  'stok.lots.release': 'Release lot',
  'stok.lots.releasing': 'Releasing…',
  'stok.lots.releaseTitle': 'Release lot {code}?',
  'stok.lots.releaseBody': 'The lot becomes available for use again.',
  'stok.lots.releaseReason': 'Reason for the release',
  'stok.lots.released': 'Lot {code} released.',
  'stok.lots.holdsTitle': 'Hold history',
  'stok.lots.holdsDesc': 'Every hold on this lot, oldest first.',
  'stok.lots.holdsEmpty': 'This lot has never been held.',
  'stok.lots.col.heldAt': 'Held',
  'stok.lots.col.holdReason': 'Reason',
  'stok.lots.col.releasedAt': 'Released',
  'stok.lots.col.releaseReason': 'Release reason',
  'stok.lots.holdOpen': 'Still on hold',
  'stok.lots.holdSource.manual': 'Manual',
  'stok.lots.holdSource.goodsReceipt': 'At receiving',
  'stok.lots.traceTitle': 'Movement trace',
  'stok.lots.traceDesc': 'Every ledger movement of this lot, oldest first (+ in, − out).',
  'stok.lots.traceEmpty': 'No movements for this lot yet.',
  'stok.lots.col.qtyAfter': 'At location after',
} as const;
